import React from 'react';
import ContentWrapper from "../../components/Content";
import privacy from './privacy';

const PrivacyPage = () => {
    return <ContentWrapper contents={privacy} title='Privacy' />
}

export default PrivacyPage